import { render, staticRenderFns } from "./QmpButton.vue?vue&type=template&id=74f08a4b&scoped=true&"
import script from "./QmpButton.vue?vue&type=script&lang=js&"
export * from "./QmpButton.vue?vue&type=script&lang=js&"
import style0 from "./QmpButton.vue?vue&type=style&index=0&id=74f08a4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f08a4b",
  null
  
)

export default component.exports